import { useState, useEffect } from "react";
import combinedServices from "../../../shared/services/user-service";
import { useNavigate } from "react-router-dom";
import getLocalData from "../../../shared/localStorage/getData";
import "../../NambaStore/store/storelist.css";
import Header from "../../../Components/clubDashboard/Header/Header";

const StoreCard = ({ store, onStoreClick, isSelected }) => {
  let images = [];
  try {
    images = JSON.parse(store.storeimage) || [];
  } catch (e) {
    images = [];
  }

  const formatDistricts = (districts) => {
    if (!districts || !Array.isArray(districts)) return "";
    return districts.map((id) => `D${id}`).join(", ");
  };

  return (
    <div
      className={`store-card-wrapper ${isSelected ? "selected" : ""}`}
      onClick={() => onStoreClick(store.id)}
    >
      <div className="inner d-flex align-items-center">
        <div className="img">
          <img
            src={
              images[0] || "https://via.placeholder.com/250x150?text=No+Image"
            }
            alt={store.storename || "Store"}
            className="store-image"
          />
        </div>
        <div className="name ms-3">
          {store.storename || "Store Name"}
          <div className="pt-1">
            {store.district && (
              <span className="store-districts">
                {formatDistricts(JSON.parse(store.district))}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const POSStoreList = () => {
  const [storeData, setStoreData] = useState([]);
  const [selectedStoreId, setSelectedStoreId] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    if (getLocalData("user_info", "isLogin")) {
      const loginUserData = getLocalData("user_info", "all").userData
        .login_user_detail.data.user.id;

      const fetchStores = async () => {
        setLoading(true);
        setError(null);
        try {
          // Get user data to find StorePOS
          const usersData = await combinedServices.getAllFilteredUserNames(1, 1000, '');
          const currentUser = usersData.data.data.data.find(user => user.id === loginUserData);
          
          if (!currentUser || !currentUser.StorePOS || currentUser.StorePOS === '0') {
            setStoreData([]);
            return;
          }

          // Parse store IDs from StorePOS
          const storeIds = currentUser.StorePOS.split(',').map(id => parseInt(id.trim()));
          
          // Get all stores and filter by user's assigned stores
          const allStoresData = await combinedServices.getstore(1, 1000, '');
          if (allStoresData && allStoresData.data.data.stores) {
            const userStores = allStoresData.data.data.stores.filter(store => 
              storeIds.includes(store.id)
            );
            setStoreData(userStores || []);
          }
        } catch (err) {
          setError("Failed to fetch stores. Please try again later.");
          console.error("Error fetching Stores:", err);
        } finally {
          setLoading(false);
        }
      };
      fetchStores();
    } else {
      setLoading(false);
    }
  }, []);

  const handleStoreClick = (id) => {
    navigate(`/posproductList`, { state: { storeId: id } });
  };

  const renderContent = () => {
    if (loading) {
      return <div className="loading-indicator">Loading stores...</div>;
    }

    if (error) {
      return <div className="error-message">{error}</div>;
    }

    if (storeData.length === 0) {
      return <div className="empty-message">No stores found.</div>;
    }

    return (
      <div className="d-flex flex-wrap productList p-0">
        {storeData.map((store) => (
          <StoreCard
            key={store.id}
            store={store}
            onStoreClick={handleStoreClick}
            isSelected={store.id === selectedStoreId}
          />
        ))}
      </div>
    );
  };

  return (
    <div className="store-page">
      <Header />
      <div className="dbRight">
        <section className="dbMid dbInner">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12 store-list-container">
                <h1 className="store-list-title">POS STORES</h1>
                {renderContent()}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default POSStoreList;